import { render, staticRenderFns } from "./yinxiao.vue?vue&type=template&id=25e9463a&"
import script from "./yinxiao.vue?vue&type=script&lang=js&"
export * from "./yinxiao.vue?vue&type=script&lang=js&"
import style0 from "./yinxiao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports